module.exports = __webpack_public_path__ + "img/Apache_logo.938aaf2e.png";